import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=7750075a&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBar: require('/workspace/components/NavBar.vue').default,AsideMenu: require('/workspace/components/AsideMenu.vue').default,FooterBar: require('/workspace/components/FooterBar.vue').default})
